import {
  Tooltip,
  TooltipAnchor,
  TooltipArrow,
  TooltipProvider,
} from "@replicate/ui";

export default function TextTooltip({
  anchorText,
  tooltipText,
  tooltipClass = "",
}: {
  anchorText: string;
  tooltipText: React.ReactNode;
  tooltipClass?: string;
}) {
  return (
    <TooltipProvider showTimeout={0}>
      <TooltipAnchor className="underline decoration-dotted cursor-help">
        {anchorText}
      </TooltipAnchor>
      <Tooltip className={`w-48 text-center text-r8-xs ${tooltipClass}`}>
        <TooltipArrow />
        {tooltipText}
      </Tooltip>
    </TooltipProvider>
  );
}
